module.exports = __webpack_public_path__ + "img/daichao1.0ee864a7.png";